import React from "react"
import { graphql } from "gatsby"
import sanitizeHtml from "sanitize-html"

import Counter from "../components/counter"

export const query = graphql`
  fragment TripleFactsFields on DatoCmsTripleFactsComponent {
    componentId: key
    title
    facts {
      id
      number
      numberSuffix
      blurbNode {
        childMarkdownRemark {
          html
        }
      }
      label
    }
  }
`

import { TripleFactsFieldsFragment } from "../../graphql-types"

export interface TripleFactsProps extends TripleFactsFieldsFragment {
  background?: "black" // Add more variants if needed: "black" | "red" | "image"
  spacing?: string
  variant?:
    | "fullwidth"
    | "background-black"
    | "minus"
    | "mobilepadding"
    | "greybackground"
}

const TripleFacts: React.FC<TripleFactsProps> = props => {
  const className = `c-triple-facts o-row ${
    props.spacing ? `${props.spacing}` : ""
  } ${props.variant ? `-${props.variant}` : ""} ${
    props.background ? `-fullwidth -background-${props.background}` : ""
  }`

  return (
    <section id={props.componentId} className={className} data-faux-href="#">
      <div className="o-wrapper">
        {props.title && (
          <h2 className="c-triple-facts__heading">{props.title}</h2>
        )}
        <div className="c-triple-facts__items">
          {props.facts.map(item => {
            const label = sanitizeHtml(item.label, {
              allowedTags: ["sup", "sub"],
              allowedAttributes: {},
            })
            const numberSuffix = sanitizeHtml(item.numberSuffix, {
              allowedTags: ["sup", "sub"],
              allowedAttributes: {},
            })
            return (
              <div key={item.id} className="c-triple-facts__item">
                {label && (
                  <div className="c-triple-facts__item__preamble">
                    <span dangerouslySetInnerHTML={{ __html: label }} />
                  </div>
                )}

                <div className="c-triple-facts__item__header">
                  <Counter className="count" end={item.number} />
                  <label className="c-heading--b">{numberSuffix}</label>
                </div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: item.blurbNode.childMarkdownRemark.html,
                  }}
                />
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default TripleFacts
